import { mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledCatalogSelector = styled.div`
  flex: 1;
  max-width: 35rem;
  ${mixin.centerElement};
  padding-top: 0.75rem;
  gap: 0.25rem;
`

export const Unsaved = styled.div`
  display: inline;
  margin-right: 0.5rem;
`
